<template>
  <div class="did-container">
    <nav class="add-navigation flex-wrap ">
      <div
        @click="$router.push({ name: 'system-admin-vendor-list' })"
        class="back-link"
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p class="my-2 mr-3">Back to Vendors</p>
      </div>
      <div class="search-container flex-wrap ">
        <search-input
          class="search-input w-auto  mr-3"
          type="text"
          v-model="SearchDid"
          @keyup.native="GetList"
          placeholder="Search for DID"
        />
        <div class="buttons-wrapper ">
          <div class="primary-button button-margin-size">
            <primary-button @click.native="() => showAddModal()"
              >Add DID</primary-button
            >
          </div>
        </div>
      </div>
    </nav>
    <div
      class="table_div"
      style="width: 100%; overflow-x: auto; overflow-y: hidden"
    >
      <table class="Invoice_table">
        <thead>
          <tr class="Invoice_table_header table-header">
            <th>Number</th>
            <th>Created On</th>
            <th>Created By</th>
            <th>Country</th>
            <th>Type</th>
            <th>State</th>
            <th>LATA</th>
            <th class="icon">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="line"
            v-if="dids.length > 0"
            v-for="(did, k) in dids"
            :key="k"
          >
            <th class="user_active">{{ did.number }}</th>
            <th>{{ did.createdOn }}</th>
            <th class="img-container">{{ did.createdBy }}</th>
            <!-- <th>{{did.country_uuid}}</th> -->
            <th>{{ getCountryNameById(did.country_uuid) }}</th>
            <th>{{ did.type }}</th>
            <th>{{ did.state ? did.state : "" }}</th>
            <th>{{ did.lata ? did.lata : "" }}</th>
            <th class="icon">
              <svg
                @click="() => deleteDid(did.number)"
                class="svg-grey"
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1"
              >
                <path
                  d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                  id="path-1"
                />
              </svg>
              <!-- <span>@click="$router.push({name: 'system-admin-vendor-did-edit', params: {id: did.did}})"</span> -->
              <svg
                @click="showEditModal(did.number)"
                class="svg-grey"
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1"
              >
                <path
                  d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                  id="path-1"
                />
              </svg>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
    <div :style="{ display: paginationCondition ? 'flex' : 'block' }">
      <div class="per-page">
        <span class="filter_by custom-row mr-3">Show Per Page:</span>
        <div class="primary-input-container choose-type perPage">
          <primary-select
            type="text"
            @input="changePerPage"
            v-model="per_page" :is-cross="false"
            class="choose-type perPage"
            placeholder="Select"
          >
            <option :value="item" v-for="(item, key) in pages" :key="key">
              {{ item }}
            </option>
          </primary-select>
        </div>
      </div>
      <div class="buttons-wrapper" :class="{ pagination: paginationCondition }">
        <pagination-component
          @change-page="changePage($event)"
          :page="Page"
          :total="TotalPages"
          :perPage="per_page"
          :qnt="dids.length"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import AddDid from "./AddDid";
import EditDid from "./EditDid";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    FiltersActions: () => import("@/components/FiltersAndActions.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
  },
  data: () => ({
    showDropDown: false,
    dids: [],
    Page: 0,
    SearchDid: "",
    per_page: 10,
    pages: [10, 50, 100],
    TotalPages: null,
    vendorId: null,
    countries: [],
  }),
  computed: {
    paginationCondition() {
      return this.dids.length < this.per_page && this.Page === 0;
    },
  },
  created() {
    this.vendorId = this.$route.params.id;
    this.setHeader();
    this.GetCountryList();
    this.GetList();
  },
  methods: {
    setHeader() {
      this.$store.commit("setPageHeader", this.$route.params.vendor_name);
    },
    changePerPage() {
      this.Page = 0;
      this.GetList(this.Searched, this.Page);
    },
    changePage(page) {
      this.Page = page;
      this.GetList(this.Searched, this.Page);
    },
    transformCountry(country) {
      return {
        id: country.country_uuid,
        name: country.nice_name,
      };
    },
    transformDids(i, k) {
      return {
        number: i.did,
        createdBy: i.created_by,
        country_uuid: i.country_uuid,
        createdOn: format(i.created_on, "YYYY:MM:DD HH:mm:ss"),
        assignedTo: i.company_ame,
        type: i.type,
        state: i.state,
        lata: i.lata,
      };
    },
    getCountryNameById(id) {
      console.log(id);
      if (!id) {
        return "";
      }
      const country_obj = this.countries.find((country) => country.id === id);
      return country_obj.name;
    },
    GetCountryList() {
      this.$store.dispatch("getCountryList", {}).then((res) => {
        this.countries = res.items.map(this.transformCountry);
      });
    },
    GetList() {
      this.$store
        .dispatch("GetDids", {
          did: this.SearchDid,
          page: this.Page,
          vendorId: this.vendorId,
          per_page: this.per_page,
        })
        .then((res) => {
          this.dids = res.items.map(this.transformDids);
          this.Total = res.total;
          this.TotalPages = res.total / res.per_page;
        });
    },
    showAddModal() {
      this.$modal.show(
        AddDid,
        { vendorId: this.vendorId, adaptive: true },
        {
          adaptive: true,
          clickToClose: false,
          height: 'auto'
        },
        {
          "before-close": this.beforeClose,
        }
      );
    },
    showEditModal(did) {
      this.$modal.show(
        EditDid,
        { didNumber: did, adaptive: true },
        {
          adaptive: true,
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": this.beforeClose,
        }
      );
    },
    beforeClose() {
      this.GetList();
    },
    deleteDid: async function (did) {
      try {
        await this.$store.dispatch("EditDid", {
          did: did,
          newDid: {
            has_vendor: false,
            vendor_type: null,
            vendor_uuid: null,
            vendor_name: null,
          },
        });

        this.$snotify.success("DID have been added.", {
          timeout: 6000,
        });
        this.GetList();
      } catch (err) {
        if (err.response) {
          err =
            err.response.data.error && err.response.data.error.message
              ? err.response.data.error.message
              : err.response.data.errors;
        }
        this.$snotify.error(err, { timeout: 6000 });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.did-container {
  padding: 0 20px;

  .buttons-wrapper.pagination {
    width: fit-content;
    flex-grow: 1;
  }
  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .perPage {
    width: 120px;
    margin-right: 15px;
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    height: fit-content;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .search-container {
      display: flex;
      justify-content: space-between;

      .search-input {
        background-color: #ffffff;

      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: flex-end;

      &.pagination {
        width: fit-content;
        flex-grow: 1;
      }
      .primary-button {
        height: 40px;
        white-space: nowrap;
      }
    }
  }
}
table.Invoice_table {
  th {
    text-align: center;
  }
  .table-header th {
    padding-right: 0;
    padding-left: 0;
    border: 1px solid #dee2e6;
    background: #51a3f3;
    color: #fff;
  }
}
table thead tr {
  background: #f8f9fe;
  height: 37px;
}
table,
tr {
  width: 100%;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 0px;
}
table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  width: 75px;
}
.Invoice_table_header th {
  color: #212b36;
  font-family: "Helvetica Neue";
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  padding: 11px 50px 10px 0;
}
.Invoice_table_header th:first-child {
  padding-left: 35px;
  padding-right: 100px;
}
// tbody th:first-child {
//     padding-left: 20px;
//     padding-right: 100px;
// }
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
  padding-right: 5px;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 15px 10px;
}
tr th.icon {
  width: 80px;
}
tbody {
  th.icon {
    padding: 7px 20px 7px 0;

    .svg-grey {
      float: right;
    }
    .edit {
      margin-right: 20px;
    }
  }
  .img-container {
    padding: 7px 0;
  }
}
.Invoice_price {
  font-family: "Helvetica Neue";
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}
// th.user_active:after {
//   content: "";
//   height: 10px;
//   width: 10px;
//   background-color: #24e2b8;
//   position: absolute;
//   border-radius: 50%;
//   left: 12px;
//   top: 20px;
// }

th.user_active {
  text-align: left;
  position: relative;
  // padding-left: 35px;
}
th .svg-grey {
  cursor: pointer;
  fill: #55616e;
}
th .number-icon {
  height: 16px;
  width: 16px;
  margin-right: 8px;
}

.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}

@media screen and (max-width: 1410px) {
  table.Invoice_table {
    width: 1300px;
  }
}
@media (max-width: 415px) {
  .button-margin-size{
    margin-top: 16px;
  }
}
</style>

